import { Node } from "../Node";
import { AbstractUploadProperty } from "./AbstractUploadProperty";

export class PImage extends AbstractUploadProperty<Node> {
  constructor(args) {
    super({
      type: "Image",
      ...args,
    });
  }
}
